import { ChartBarIcon } from '@heroicons/react/24/solid';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { playerUIActions } from './playerUISlice.ts';
import { useAppDispatch } from '../../stores/store.ts';

interface IProps {
    qualityLevels: { height: number }[],
    selectedLevel: number,
    isOpen: boolean,
    setIsOpen: (isOpen: boolean) => void,
    onChangeSelectLevel: (qualityLevel: number) => void;
}

const PlayerQualityLevel = forwardRef<{ closePopup: () => void }, IProps>(({
                                                                               qualityLevels,
                                                                               selectedLevel,
                                                                               isOpen,
                                                                               setIsOpen,
                                                                               onChangeSelectLevel,
                                                                           }, ref) => {
        const popupRef = useRef<HTMLDivElement>(null);
        const dispatch = useAppDispatch();

        const handleAnimationEnd = () => {
            if (popupRef.current)
                popupRef.current.removeAttribute('close');
        };

        const closePopup = () => {
            if (isOpen && popupRef.current) {
                popupRef.current.setAttribute('close', '');
                setIsOpen(false);
            }
        };

        const togglePopup = () => {
            if (popupRef.current) {
                if (isOpen) {
                    popupRef.current.setAttribute('close', '');
                }
                setIsOpen(!isOpen);
            }
        };

        const handleButtonOnClick = () => {
            togglePopup();
        };

        useImperativeHandle(ref, () => ({
            closePopup,
        }));
        return (
            <div className="relative flex items-center">
                <button onClick={handleButtonOnClick}>
                    <ChartBarIcon className="w-7 h-7" />
                </button>
                <div
                    className={`popup`}
                    ref={popupRef}
                    data-open={isOpen ? isOpen : undefined}
                    onAnimationEnd={handleAnimationEnd}
                    onMouseEnter={() => {
                        dispatch(playerUIActions.setIsMenuUIHovered(true));
                    }}
                    onMouseLeave={() => {
                        dispatch(playerUIActions.setIsMenuUIHovered(false));
                    }}
                >
                    <div className={`absolute top-11 md:top-14 right-1/2 translate-x-1/2 bg-white p-2 rounded-sm z-10`}>
                        <ul className="text-neutral-700 text-center">
                            <li>
                                <button
                                    disabled={selectedLevel === -1}
                                    className="rounded-sm w-full px-8 py-1 hover:bg-neutral-200 transition-colors disabled:bg-neutral-100 disabled:text-neutral-500"
                                    onClick={() => {
                                        onChangeSelectLevel(-1);
                                        setIsOpen(!isOpen);
                                    }}
                                >
                                    auto
                                </button>
                            </li>
                            {qualityLevels.sort((a, b) => a.height - b.height).map((x, index) => (
                                <li key={index}>
                                    <button
                                        disabled={selectedLevel === index}
                                        className="rounded-sm w-full px-6 py-1 hover:bg-neutral-200 transition-colors disabled:bg-neutral-100 disabled:text-neutral-500"
                                        onClick={() => {
                                            onChangeSelectLevel(index);
                                            setIsOpen(!isOpen);
                                        }}
                                    >
                                        {x.height}p
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div
                        className={`absolute right-1 -bottom-4 border-solid border-b-white border-b-8 border-x-transparent border-x-8 border-t-0`} />
                </div>
            </div>
        );
    },
);
export default PlayerQualityLevel;